import script from "./ProductsCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsCarousel.vue?vue&type=script&setup=true&lang=js"

import "./ProductsCarousel.vue?vue&type=style&index=0&id=63326a25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63326a25"]])

export default __exports__